/* eslint-disable import/prefer-default-export */
import appointment from "./appointment";
import auth from "./auth";
import errors from "./errors";
import sider from "./sider";
import home from "./home";
import enums from "./enums";
import im from "./im";
import preferences from "./preferences";

export const frTranslation = {
  auth,
  errors,
  sider,
  appointment,
  im,
  home,
  enums,
  preferences,
};
/* eslint-enable import/prefer-default-export */
